const DEFAULT_BRAND_IMAGE =
  'https://s3.amazonaws.com/com.givebacks.public/images/Givebacks+Default+Brand';

const DEFAULT_IMAGE_PLACEHOLDER =
  'https://s3.us-east-1.amazonaws.com/com.givebacks.public/images/no-image-fallback.jpg';

const DEFAULT_PTA_IMAGE =
  'https://s3.amazonaws.com/com.memberhub.public/static/images/pta_logo.png';

const STONES_IMAGE =
  'https://s3.amazonaws.com/com.givebacks.public/images/donations/rocksOnWater.png';

const DEFAULT_PEER_PROFILE_BANNER_IMAGE =
  'https://s3.us-east-1.amazonaws.com/com.givebacks.public/images/crowdfunding/ParticipantsPage-NoImage.png';

export {
  DEFAULT_BRAND_IMAGE,
  DEFAULT_IMAGE_PLACEHOLDER,
  DEFAULT_PEER_PROFILE_BANNER_IMAGE,
  DEFAULT_PTA_IMAGE,
  STONES_IMAGE,
};
